/* info.icon.svg.js */

"use strict";
module.exports = {
    icon: ` <svg viewBox="0 0 20 20" preserveAspectRatio="none">
                <path class="foreground-gl" d="M9.92,19.81a9.9,9.9,0,1,1,9.9-9.9h0A9.91,9.91,0,0,1,9.92,19.81Zm0-18.42a8.52,8.52,0,1,0,8.5,8.56,8.52,8.52,0,0,0-8.5-8.56Z" transform="translate(-0.02 -0.01)"/><path class="foreground-gl" d="M8.52,3.42h2.6V5.94H8.52Zm0,3.94h2.6v9H8.52Z" transform="translate(-0.02 -0.01)"/>
            </svg>`,
};
